module.exports = __webpack_public_path__ + "static/media/lotus.b13a42af.svg";